import { Injectable } from '@angular/core';
import {MovilDTO} from "../../dtos/movil.dto";

@Injectable({
  providedIn: 'root'
})
export class MovilService {

  private movilSeleccionado: MovilDTO;

  constructor() {}

  getMovilSeleccionado() {
    return this.movilSeleccionado;
  }

  setMovilSeleccionado(movil: MovilDTO) {
    this.movilSeleccionado = movil;
  }

}